import { useCallback, useEffect, useRef, useState } from 'react'

const STRIPE_CONNECT_ROUTE_READY_DELAY_MS = 150

export function useStripeConnectRouteReady(): {
  isReady: boolean
  setReady: (nextReady: boolean) => void
} {
  const [isReady, setIsReady] = useState(false)
  const isReadyRef = useRef(false)
  const readyTimeoutRef = useRef<number | null>(null)

  useEffect(() => {
    isReadyRef.current = isReady
  }, [isReady])

  useEffect(
    () => () => {
      if (readyTimeoutRef.current) {
        window.clearTimeout(readyTimeoutRef.current)
        readyTimeoutRef.current = null
      }
    },
    []
  )

  const setReady = useCallback((nextReady: boolean) => {
    if (!nextReady) {
      if (readyTimeoutRef.current) {
        window.clearTimeout(readyTimeoutRef.current)
        readyTimeoutRef.current = null
      }

      if (isReadyRef.current) {
        isReadyRef.current = false
        setIsReady(false)
      }

      return
    }

    if (isReadyRef.current || readyTimeoutRef.current) {
      return
    }

    readyTimeoutRef.current = window.setTimeout(() => {
      readyTimeoutRef.current = null
      isReadyRef.current = true
      setIsReady(true)
    }, STRIPE_CONNECT_ROUTE_READY_DELAY_MS)
  }, [])

  return {
    isReady,
    setReady,
  }
}
